import { Component } from '@theme/component';

class CountrySelector extends Component {
    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    /**
     * Close the country selector and show the menu content for the correct parentLinkHandle
     * @param {any} event - event with dataset.parentlinkhandle
     */
    closeCountrySelector(event) {
        const parentReferenceId = event.target.dataset.parentreference;
        const parentReference = parentReferenceId.split('-').pop();

        const countrySelector = document.querySelector(
            '#country-selector-container-' + parentReference
        );
        const menuContent = document.getElementById(parentReferenceId);
        if (countrySelector) {
            countrySelector.classList.add('hidden');
            menuContent?.classList.remove('hidden');
        }
        this.resizeSubMenu(event);
    }

    getParentReference() {
        return this.dataset.parentreference;
    }

    /**
     * Handle continent button click: highlight selected and update country list
     * @param {any} event
     */
    handleContinentClick(event) {
        const btn = event.target;
        const selectedContinent = btn.dataset.continent;
        // Highlight selected button
        const allBtns = this.querySelectorAll('button[data-continent]');
        allBtns.forEach((b) => b.classList.remove('text-(--color-orange)'));
        btn.classList.add('text-(--color-orange)');

        // Show dot on selected button
        const allDots = this.querySelectorAll('button[data-continent] span.dot');
        allDots.forEach((dot) => dot.classList.add('invisible'));
        const dot = btn.querySelector('span.dot');
        dot.classList.remove('invisible');
        // Update country list
        const countryGroups = this.querySelectorAll('.country-group');
        countryGroups.forEach((group) => {
            if (group.getAttribute('data-continent') === selectedContinent) {
                group.classList.remove('hidden');
            } else {
                group.classList.add('hidden');
            }
        });

        this.resizeSubMenu(event);
    }

    /**
     * Handle continent button click: highlight selected and update country list
     * @param {any} event
     */
    resizeSubMenu(event) {
        if (this.dataset.scope !== 'header') return;
        const headerMenuContent = event.target.closest('header-menu-content');
        if (headerMenuContent && typeof headerMenuContent.resizeHeight === 'function') {
            headerMenuContent.resizeHeight();
        }
    }
}

if (!customElements.get('country-selector')) {
    customElements.define('country-selector', CountrySelector);
}
